import TextCell from 'components/TextCell';
import type { ManagedTeamsType } from '../..';

interface CellProps {
  rowData: ManagedTeamsType;
}

export default function PlatformAccountsCountCell({
  rowData: { totals },
}: CellProps) {
  return <TextCell text={String(totals?.platformAccounts)} />;
}
